<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <nav ref="mainDiv" class="sticky-navbar">
    <div
      name="navbar-placehodler"
      :class="{
        [`${headerClassName}--placeholder`]: true,
        [`${headerClassName}--placeholder--visible`]: floating
      }"
    ></div>
    <div v-if="scrollDetected" :class="{ [headerClassName]: true, floating }">
      <slot />
    </div>
  </nav>
</template>
<script>
// let timer;

export default {
  props: {
    headerClassName: {
      type: String,
      default: "page-header"
    }
  },
  data() {
    return {
      scrollDetected: false,
      floating: false
    };
  },
  methods: {
    isFloating() {
      const position = this.$refs.mainDiv.getBoundingClientRect();
      if (this.floating && position.y >= 0) {
        return false;
      } else {
        if (window.scrollY > 20) {
          return true;
        }
      }
    },
    handleScroll() {
      // if (timer) {
      //   clearTimeout(timer);
      // }
      // timer = setTimeout(() => {
      this.floating = this.isFloating();
      if (!this.scrollDetected) {
        this.scrollDetected = true;
      }
      // }, 100);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style lang="scss" scoped>
.sticky-navbar {
  z-index: 15;
  position: relative;
}
</style>
